<script setup lang="js">
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min';
  import navConfig from '../../src/assets/navConfig.json'
  import { BIconChevronRight } from 'bootstrap-icons-vue';

  // Reactive variables
  const isMobile = ref(window.matchMedia("(max-width: 768px)").matches);
  const isMenuOpen = ref(false);
  let mediaQuery = null;

  // Functions
  function toggleMenu() {
    isMenuOpen.value = !isMenuOpen.value;
  }

  // Update isMobile when the screen size changes
  const handleResize = (event) => {
    isMobile.value = event.matches; // Correctly update the reactive value
  };

  // close the nav dropdown if route to other page
  const closeDropdown = (event) => {
    const dropdownContainer = event.currentTarget.closest('.nav-item.dropdown');

    // Close the dropdown
    if (dropdownContainer) {
      const toggle = dropdownContainer.querySelector('.dropdown-toggle');
      if (toggle) {
        let instance = bootstrap.Dropdown.getInstance(toggle);
        if (!instance) {
          instance = new bootstrap.Dropdown(toggle);
        }
        instance.hide();
      }
    }

    // Close the main navbar (burger menu) if it's open
    const navbarToggler = document.querySelector('.navbar-toggler');
    const isNavbarExpanded = navbarToggler.getAttribute('aria-expanded') === 'true';

    if (isNavbarExpanded) {
      navbarToggler.click();  // Simulate a click on the navbar toggler to close it
    }
  };

  const toggleBurgerIcon = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarIcon = navbarToggler.querySelector('.mobil-menu');

    // Toggle classes to change the SVG icon
    if (navbarToggler.getAttribute('aria-expanded') === 'true') {
      // Change the hamburger to "X" icon (you can add classes to do this with CSS or manipulate SVG)
      navbarIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#fff" class="bi bi-x-lg" viewBox="0 0 16 16">
    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
  </svg>
      `;
    } else {
      // Revert back to hamburger icon
      navbarIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40" fill="#fff">
          <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"></path>
        </svg>
      `;
    }
  };


  onMounted(() => {
    mediaQuery = window.matchMedia("(max-width: 768px)");
    isMobile.value = mediaQuery.matches;
    mediaQuery.addEventListener("change", handleResize);
    handleResize(mediaQuery);

  });

  onBeforeUnmount(() => {

    if (mediaQuery) {
      mediaQuery.removeEventListener("change", handleResize);
    }

  });
</script>

<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <RouterLink to="/" aria-label="GEDE-Tech">
        <template v-if="!isMobile">
          <div class="logo">
            <svg
              width="60"
              height="60"
              viewBox="0 0 5888 6268"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1308.48 1180.43L3208.85 26L4214.74 578.457V1953.74L5864.94 2859.3V5144.7L4948.31 5703.67L3883.13 5129.06L2076.57 6241.14L23.1006 5105.61V4022.85L1308.48 3235.85V1180.43Z"
                fill="white"
              />
              <path
                d="M1308.48 1180.43L3208.85 26L4214.74 578.457M1308.48 1180.43L2322.18 1736.14M1308.48 1180.43V3235.85M2322.18 4074.31L1308.48 3515.34V3235.85M2322.18 4074.31V1736.14M2322.18 4074.31L3081.16 3611.11M2322.18 1736.14L4214.74 578.457M4214.74 578.457V1953.74M4214.74 1953.74L3993.24 1833.21L3081.16 2387.62M4214.74 1953.74L5864.94 2859.3M3081.16 3611.11V2387.62M3081.16 3611.11L3883.13 4060.63M3081.16 2387.62L4948.31 3413.06M5864.94 2859.3V5144.7L4948.31 5703.67M5864.94 2859.3L4948.31 3413.06M3883.13 5129.06V4060.63M3883.13 5129.06L4948.31 5703.67M3883.13 5129.06L2076.57 6241.14M3883.13 4060.63L2076.57 5159.03M4948.31 3413.06V5703.67M2076.57 5159.03V6241.14M2076.57 5159.03L23.1006 4022.85M2076.57 6241.14L23.1006 5105.61V4022.85M23.1006 4022.85L1308.48 3235.85"
                stroke="#121212"
                stroke-width="45"
              />
              <path
                d="M1334.54 1224.08L2296.12 1751.13V4030.29L1334.54 3500.05V1224.08Z"
                fill="url(#paint0_linear_69_2)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_69_2"
                  x1="1494.8"
                  y1="1280.76"
                  x2="2107.19"
                  y2="4060.63"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#00FF57" />
                  <stop offset="1" stop-color="#007A2A" />
                </linearGradient>
              </defs>
            </svg>

            <svg width="168" viewBox="0 0 9711 1201" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1145.74 703.351C1145.74 775.892 1132.94 842.566 1107.33 903.373C1082.8 964.179 1046.53 1016.98 998.521 1061.79C951.583 1105.53 894.51 1139.66 827.303 1164.2C760.096 1188.74 684.355 1201 600.079 1201C517.937 1201 440.062 1185.54 366.454 1154.6C293.913 1122.6 230.44 1079.39 176.034 1024.99C121.628 970.58 78.4236 907.106 46.4202 834.565C15.4836 760.957 0.0153097 683.083 0.0153097 600.94C0.0153097 518.798 15.4836 441.457 46.4202 368.916C78.4236 295.308 121.628 231.301 176.034 176.895C230.44 122.49 293.913 79.8184 366.454 48.8817C440.062 16.8784 517.937 0.87668 600.079 0.87668C654.485 0.87668 707.291 9.94432 758.496 28.0796C810.768 45.1481 858.773 68.6172 902.511 98.487C946.249 127.29 985.187 160.894 1019.32 199.298C1054.53 236.635 1082.8 276.106 1104.13 317.71H1027.32C1007.06 284.64 981.453 253.17 950.516 223.3C920.646 192.364 887.043 165.161 849.706 141.692C812.368 118.222 772.364 99.5538 729.693 85.6856C688.088 70.7507 644.884 63.2833 600.079 63.2833C526.471 63.2833 456.597 77.6848 390.457 106.488C325.383 135.291 268.31 174.228 219.239 223.3C171.234 271.305 132.829 327.845 104.026 392.918C75.2233 457.992 60.8218 527.333 60.8218 600.94C60.8218 674.548 75.2233 744.422 104.026 810.563C132.829 875.636 171.234 932.709 219.239 981.781C268.31 1029.79 325.383 1068.19 390.457 1096.99C456.597 1125.8 526.471 1140.2 600.079 1140.2C672.62 1140.2 738.761 1130.06 798.5 1109.79C858.24 1089.53 908.912 1060.72 950.516 1023.39C993.188 984.981 1026.26 939.11 1049.73 885.771C1073.2 831.365 1084.93 770.558 1084.93 703.351H672.087V642.545H1145.74V703.351ZM1465.73 40.8809H2192.21V101.687H1526.54V642.545H2075.4V703.351H1526.54V1100.19H2192.21V1161H1465.73V40.8809ZM2512.72 40.8809H2879.16C2957.03 40.8809 3029.57 55.8158 3096.78 85.6856C3165.06 114.489 3224.26 153.96 3274.4 204.098C3324.54 254.237 3364.01 313.443 3392.81 381.717C3422.68 449.991 3437.62 522.532 3437.62 599.34C3437.62 676.148 3422.68 748.69 3392.81 816.963C3364.01 885.237 3324.54 944.977 3274.4 996.182C3224.26 1047.39 3165.06 1087.93 3096.78 1117.8C3029.57 1146.6 2957.03 1161 2879.16 1161H2512.72V40.8809ZM2879.16 1100.19C2947.43 1100.19 3011.97 1087.39 3072.78 1061.79C3133.59 1035.12 3186.39 998.849 3231.2 952.978C3276 907.106 3311.2 854.301 3336.81 794.561C3363.48 733.755 3376.81 668.681 3376.81 599.34C3376.81 531.066 3363.48 467.06 3336.81 407.32C3311.2 346.513 3276 293.708 3231.2 248.903C3186.39 203.031 3133.59 167.294 3072.78 141.692C3011.97 115.022 2947.43 101.687 2879.16 101.687H2573.53V1100.19H2879.16ZM3765.98 40.8809H4492.46V101.687H3826.78V642.545H4375.64V703.351H3826.78V1100.19H4492.46V1161H3765.98V40.8809ZM5297.82 712.952V773.759H4844.97V712.952H5297.82ZM5585.86 101.687V40.8809H6312.34V101.687H5979.5V1161H5918.69V101.687H5585.86ZM6583.46 40.8809H7309.94V101.687H6644.27V642.545H7193.13V703.351H6644.27V1100.19H7309.94V1161H6583.46V40.8809ZM7619.44 600.94C7619.44 674.548 7633.84 744.422 7662.64 810.563C7691.45 875.636 7730.38 932.709 7779.45 981.781C7828.53 1029.79 7885.6 1068.19 7950.67 1096.99C8015.75 1125.8 8085.09 1140.2 8158.69 1140.2C8209.9 1140.2 8257.37 1133.26 8301.11 1119.4C8344.85 1104.46 8384.32 1085.26 8419.52 1061.79C8455.79 1037.25 8487.8 1009.52 8515.53 978.581C8544.34 947.644 8568.34 915.641 8587.54 882.57H8664.35C8639.81 925.242 8610.48 965.779 8576.34 1004.18C8542.2 1042.59 8503.8 1076.72 8461.13 1106.59C8419.52 1135.4 8373.12 1158.33 8321.91 1175.4C8270.71 1192.47 8216.3 1201 8158.69 1201C8076.55 1201 7998.68 1185.54 7925.07 1154.6C7852.53 1122.6 7789.06 1079.39 7734.65 1024.99C7680.24 970.58 7637.04 907.106 7605.04 834.565C7574.1 760.957 7558.63 683.083 7558.63 600.94C7558.63 518.798 7574.1 441.457 7605.04 368.916C7637.04 295.308 7680.24 231.301 7734.65 176.895C7789.06 122.49 7852.53 79.8184 7925.07 48.8817C7998.68 16.8784 8076.55 0.87668 8158.69 0.87668C8218.43 0.87668 8273.91 9.94432 8325.11 28.0796C8377.38 45.1481 8424.86 68.6172 8467.53 98.487C8510.2 127.29 8548.07 160.894 8581.14 199.298C8614.21 237.702 8641.95 277.173 8664.35 317.71H8585.94C8565.67 284.64 8541.14 253.17 8512.33 223.3C8484.6 192.364 8452.59 165.161 8416.32 141.692C8380.05 118.222 8340.05 99.5538 8296.31 85.6856C8253.64 70.7507 8207.77 63.2833 8158.69 63.2833C8085.09 63.2833 8015.75 77.6848 7950.67 106.488C7885.6 135.291 7828.53 174.228 7779.45 223.3C7730.38 271.305 7691.45 327.845 7662.64 392.918C7633.84 457.992 7619.44 527.333 7619.44 600.94ZM9649.39 40.8809H9710.2V1161H9649.39V703.351H9044.53V1161H8983.72V40.8809H9044.53V642.545H9649.39V40.8809Z"
                fill="white"
              />
            </svg>
          </div>
        </template>
        <template v-if="isMobile">
          <div class="logo">
            <svg
              width="60"
              height="60"
              viewBox="0 0 5888 6268"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1308.48 1180.43L3208.85 26L4214.74 578.457V1953.74L5864.94 2859.3V5144.7L4948.31 5703.67L3883.13 5129.06L2076.57 6241.14L23.1006 5105.61V4022.85L1308.48 3235.85V1180.43Z"
                fill="white"
              />
              <path
                d="M1308.48 1180.43L3208.85 26L4214.74 578.457M1308.48 1180.43L2322.18 1736.14M1308.48 1180.43V3235.85M2322.18 4074.31L1308.48 3515.34V3235.85M2322.18 4074.31V1736.14M2322.18 4074.31L3081.16 3611.11M2322.18 1736.14L4214.74 578.457M4214.74 578.457V1953.74M4214.74 1953.74L3993.24 1833.21L3081.16 2387.62M4214.74 1953.74L5864.94 2859.3M3081.16 3611.11V2387.62M3081.16 3611.11L3883.13 4060.63M3081.16 2387.62L4948.31 3413.06M5864.94 2859.3V5144.7L4948.31 5703.67M5864.94 2859.3L4948.31 3413.06M3883.13 5129.06V4060.63M3883.13 5129.06L4948.31 5703.67M3883.13 5129.06L2076.57 6241.14M3883.13 4060.63L2076.57 5159.03M4948.31 3413.06V5703.67M2076.57 5159.03V6241.14M2076.57 5159.03L23.1006 4022.85M2076.57 6241.14L23.1006 5105.61V4022.85M23.1006 4022.85L1308.48 3235.85"
                stroke="#121212"
                stroke-width="45"
              />
              <path
                d="M1334.54 1224.08L2296.12 1751.13V4030.29L1334.54 3500.05V1224.08Z"
                fill="url(#paint0_linear_69_2)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_69_2"
                  x1="1494.8"
                  y1="1280.76"
                  x2="2107.19"
                  y2="4060.63"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#00FF57" />
                  <stop offset="1" stop-color="#007A2A" />
                </linearGradient>
              </defs>
            </svg>
            <svg width="168" viewBox="0 0 9711 1201" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1145.74 703.351C1145.74 775.892 1132.94 842.566 1107.33 903.373C1082.8 964.179 1046.53 1016.98 998.521 1061.79C951.583 1105.53 894.51 1139.66 827.303 1164.2C760.096 1188.74 684.355 1201 600.079 1201C517.937 1201 440.062 1185.54 366.454 1154.6C293.913 1122.6 230.44 1079.39 176.034 1024.99C121.628 970.58 78.4236 907.106 46.4202 834.565C15.4836 760.957 0.0153097 683.083 0.0153097 600.94C0.0153097 518.798 15.4836 441.457 46.4202 368.916C78.4236 295.308 121.628 231.301 176.034 176.895C230.44 122.49 293.913 79.8184 366.454 48.8817C440.062 16.8784 517.937 0.87668 600.079 0.87668C654.485 0.87668 707.291 9.94432 758.496 28.0796C810.768 45.1481 858.773 68.6172 902.511 98.487C946.249 127.29 985.187 160.894 1019.32 199.298C1054.53 236.635 1082.8 276.106 1104.13 317.71H1027.32C1007.06 284.64 981.453 253.17 950.516 223.3C920.646 192.364 887.043 165.161 849.706 141.692C812.368 118.222 772.364 99.5538 729.693 85.6856C688.088 70.7507 644.884 63.2833 600.079 63.2833C526.471 63.2833 456.597 77.6848 390.457 106.488C325.383 135.291 268.31 174.228 219.239 223.3C171.234 271.305 132.829 327.845 104.026 392.918C75.2233 457.992 60.8218 527.333 60.8218 600.94C60.8218 674.548 75.2233 744.422 104.026 810.563C132.829 875.636 171.234 932.709 219.239 981.781C268.31 1029.79 325.383 1068.19 390.457 1096.99C456.597 1125.8 526.471 1140.2 600.079 1140.2C672.62 1140.2 738.761 1130.06 798.5 1109.79C858.24 1089.53 908.912 1060.72 950.516 1023.39C993.188 984.981 1026.26 939.11 1049.73 885.771C1073.2 831.365 1084.93 770.558 1084.93 703.351H672.087V642.545H1145.74V703.351ZM1465.73 40.8809H2192.21V101.687H1526.54V642.545H2075.4V703.351H1526.54V1100.19H2192.21V1161H1465.73V40.8809ZM2512.72 40.8809H2879.16C2957.03 40.8809 3029.57 55.8158 3096.78 85.6856C3165.06 114.489 3224.26 153.96 3274.4 204.098C3324.54 254.237 3364.01 313.443 3392.81 381.717C3422.68 449.991 3437.62 522.532 3437.62 599.34C3437.62 676.148 3422.68 748.69 3392.81 816.963C3364.01 885.237 3324.54 944.977 3274.4 996.182C3224.26 1047.39 3165.06 1087.93 3096.78 1117.8C3029.57 1146.6 2957.03 1161 2879.16 1161H2512.72V40.8809ZM2879.16 1100.19C2947.43 1100.19 3011.97 1087.39 3072.78 1061.79C3133.59 1035.12 3186.39 998.849 3231.2 952.978C3276 907.106 3311.2 854.301 3336.81 794.561C3363.48 733.755 3376.81 668.681 3376.81 599.34C3376.81 531.066 3363.48 467.06 3336.81 407.32C3311.2 346.513 3276 293.708 3231.2 248.903C3186.39 203.031 3133.59 167.294 3072.78 141.692C3011.97 115.022 2947.43 101.687 2879.16 101.687H2573.53V1100.19H2879.16ZM3765.98 40.8809H4492.46V101.687H3826.78V642.545H4375.64V703.351H3826.78V1100.19H4492.46V1161H3765.98V40.8809ZM5297.82 712.952V773.759H4844.97V712.952H5297.82ZM5585.86 101.687V40.8809H6312.34V101.687H5979.5V1161H5918.69V101.687H5585.86ZM6583.46 40.8809H7309.94V101.687H6644.27V642.545H7193.13V703.351H6644.27V1100.19H7309.94V1161H6583.46V40.8809ZM7619.44 600.94C7619.44 674.548 7633.84 744.422 7662.64 810.563C7691.45 875.636 7730.38 932.709 7779.45 981.781C7828.53 1029.79 7885.6 1068.19 7950.67 1096.99C8015.75 1125.8 8085.09 1140.2 8158.69 1140.2C8209.9 1140.2 8257.37 1133.26 8301.11 1119.4C8344.85 1104.46 8384.32 1085.26 8419.52 1061.79C8455.79 1037.25 8487.8 1009.52 8515.53 978.581C8544.34 947.644 8568.34 915.641 8587.54 882.57H8664.35C8639.81 925.242 8610.48 965.779 8576.34 1004.18C8542.2 1042.59 8503.8 1076.72 8461.13 1106.59C8419.52 1135.4 8373.12 1158.33 8321.91 1175.4C8270.71 1192.47 8216.3 1201 8158.69 1201C8076.55 1201 7998.68 1185.54 7925.07 1154.6C7852.53 1122.6 7789.06 1079.39 7734.65 1024.99C7680.24 970.58 7637.04 907.106 7605.04 834.565C7574.1 760.957 7558.63 683.083 7558.63 600.94C7558.63 518.798 7574.1 441.457 7605.04 368.916C7637.04 295.308 7680.24 231.301 7734.65 176.895C7789.06 122.49 7852.53 79.8184 7925.07 48.8817C7998.68 16.8784 8076.55 0.87668 8158.69 0.87668C8218.43 0.87668 8273.91 9.94432 8325.11 28.0796C8377.38 45.1481 8424.86 68.6172 8467.53 98.487C8510.2 127.29 8548.07 160.894 8581.14 199.298C8614.21 237.702 8641.95 277.173 8664.35 317.71H8585.94C8565.67 284.64 8541.14 253.17 8512.33 223.3C8484.6 192.364 8452.59 165.161 8416.32 141.692C8380.05 118.222 8340.05 99.5538 8296.31 85.6856C8253.64 70.7507 8207.77 63.2833 8158.69 63.2833C8085.09 63.2833 8015.75 77.6848 7950.67 106.488C7885.6 135.291 7828.53 174.228 7779.45 223.3C7730.38 271.305 7691.45 327.845 7662.64 392.918C7633.84 457.992 7619.44 527.333 7619.44 600.94ZM9649.39 40.8809H9710.2V1161H9649.39V703.351H9044.53V1161H8983.72V40.8809H9044.53V642.545H9649.39V40.8809Z"
                fill="white"
              />
            </svg>
          </div>
        </template>
      </RouterLink>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        @click="toggleBurgerIcon"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="mobil-menu">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="40px"
            viewBox="0 -960 960 960"
            width="40px"
            fill="#e8eaed"
          >
            <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"></path>
          </svg>
        </span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-items-group mr-auto navbar-nav">
          <li v-for="(item, index) in navConfig" :key="index" class="nav-item dropdown">
            <RouterLink
              :to="item.link"
              class="nav-link dropdown-toggle"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ item.name }}
            </RouterLink>
            <ul v-if="item.submenu.length" class="dropdown-menu">
              <template v-for="(sub, subIndex) in item.submenu" :key="subIndex">
                <li v-if="sub.type === 'headline'" class="dropdown-headline">{{ sub.title }}</li>
                <li v-if="sub.type === 'divider'">
                  <hr class="dropdown-divider" />
                </li>
                <li v-if="sub.type === 'link'">
                  <RouterLink
                    :to="sub.path ? sub.path : { path: item.link, hash: sub.hash }"
                    @click="closeDropdown"
                    class="dropdown-item"
                  >
                    {{ sub.title }}
                    <BIconChevronRight class="chevron-right" />
                  </RouterLink>
                </li>
              </template>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped lang="scss">
  @import '@/scss/variables.scss';

  .navbar {
    display: flex;
    justify-content: center;
    padding: 0 40px;
    background-color: $brand-primary-color;
    color: $brand-white;
    height: 100%;
    height: 100px;
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    border-bottom: 1px solid $brand-white;

    .container-fluid {
      @include mobile {
        padding: 0;
      }
    }

    @include mobile {
      padding: 0;

      .navbar-toggler {
        padding: 0 25px 0 0;
        @media (max-width: 359px) {
          padding: 0 10px 0 0;
        }

        &:focus {
          box-shadow: unset;
        }
      }
    }

    .navbar-collapse {
      justify-content: right;

      @include mobile {
        border-top: 1px solid $brand-white;
        padding: 0 25px;
        background-color: $brand-primary-color;

        &.show {
          border-bottom: 1px solid $brand-white;
        }
      }
    }

    .logo {
      display: flex;
      gap: 40px;
      justify-content: center;
      align-items: center;
      padding: 15px;

      @include mobile {
        padding: 10px 0 10px 25px;

        @media (max-width: 359px) {
          padding: 10px 0 10px 10px;
        }
        gap: 15px;
      }
    }

    ul.navbar-items-group {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      margin: 0;
      padding: 0;

      li.nav-item {
        position: relative;
        display: inline-block;
        color: $brand-white;
        text-decoration: none;
        font-size: 1.125rem;
        list-style: none;
        padding: 0 40px;

        .nav-link {
          color: $brand-white;

          &:after {
            display: none;
          }

          &.show {
            color: $brand-secondary-color;
          }

          &:hover,
          &:focus {
            color: $brand-secondary-color;
          }
        }

        .dropdown-menu {
          left: 45px;
          min-width: calc(100% - 40px);
          padding: 0;
          box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 4px 0px;
          top: 40px;
          z-index: 999;

          li {
            .dropdown-item {
              padding: 0;
              margin: 10px 16px 10px 30px;

              &:hover {
                text-decoration: underline;
                text-decoration-color: $brand-primary-color; // Set the underline color
                text-decoration-style: solid; // Make the underline solid
                background-color: unset;
              }

              .chevron-right {
                font-size: 14px;
                transform: translateY(-12%);
              }
            }

            &.dropdown-headline {
              color: $brand-tertiary-color;
              border-radius: 4px 4px 0 0;
              font-weight: 700;
              padding: 4px 16px;

              &:first-child {
                padding-top: 10px;
                padding-bottom: 10px;
              }

              &:not(:first-child) {
                margin-top: 10px;
                padding-top: 0;
                padding-bottom: 10px;
              }
            }

            .dropdown-divider {
              margin: 0;
            }
          }
        }
      }

      @include mobile {
        flex-direction: column;
        align-items: flex-start;

        li.nav-item {
          margin-top: 15px;
          padding: 0;
          width: 100%;
          text-align: left;

          &:last-child {
            margin-bottom: 15px;
          }

          .nav-link {
            padding: 0;
          }

          /*     .dropdown-menu {
          li.dropdown-headline {
            background-color: $brand-divider-color;
          }
        } */
        }
      }
    }
  }
</style>
